// used to render destination page (matches with backend)
export const DESTINATION_SEGMENT_ID = 'DESTINATION';
export const HOLIDAY_TYPE_SEGMENT_ID = 'HOLIDAY_TYPE';

// form type values for hero planner schedules
export const FORM_TYPE_DEFAULT = 'DEFAULT';
export const FORM_TYPE_CUSTOM = 'CUSTOM';

// campaign value surfaced on offer details when tagged + within the campaign window (see svc-customer-communication LUX_PLUS_MONTH_CAMPAIGN_DISPLAY_TAG)
export const LUX_PLUS_MONTH_CAMPAIGN = 'lux_plus_month';

// the `campaign` flag above is evaluated backend-side against "now" at fetch time, not against a schedule's
// send date, so we re-check the send date against this window ourselves before trusting the flag
export const LUX_PLUS_MONTH_CAMPAIGN_START_DATE = '2026-08-15T00:00:00+10:00';
export const LUX_PLUS_MONTH_CAMPAIGN_END_DATE = '2026-09-15T23:59:00+10:00';

// a hero deals schedule uses either the default Braze banner (emailBannerId) or a text banner (banner)
export enum HERO_DEALS_BANNER_TYPE {
  DEFAULT = 'DEFAULT',
  TEXT = 'TEXT',
}

// colour palettes for banner sections (matches bannerSectionSchema `palette` in svc-customer-communication)
export const BANNER_SECTION_PALETTES: Array<{ id: CustomerCommunication.BannerSectionPalette; name: string }> = [
  { id: 'TEAL', name: 'Teal' },
  { id: 'NEUTRAL', name: 'Neutral' },
];
// matches the palette svc-customer-communication defaults to when none is sent
export const DEFAULT_BANNER_SECTION_PALETTE: CustomerCommunication.BannerSectionPalette = 'NEUTRAL';

// banner tags are free text ordered by position (from 1); the backend accepts a list for future use, but the admin only
// lets a banner have one tag, so it always sits in the first position
export const BANNER_SECTION_TAG_POSITION = 1;

// tag styles for banner tags (matches bannerTagSchema `bannerTagType` in svc-customer-communication)
export enum BANNER_TAG_TYPE {
  OUTLINE = 'OUTLINE',
  URGENT = 'URGENT',
  FILLED_1 = 'FILLED_1',
  URGENT_FILLED_1 = 'URGENT_FILLED_1',
}
export const BANNER_TAG_TYPES: Array<{ id: BANNER_TAG_TYPE; name: string }> = [
  { id: BANNER_TAG_TYPE.OUTLINE, name: 'Outline' },
  { id: BANNER_TAG_TYPE.URGENT, name: 'Urgent' },
  { id: BANNER_TAG_TYPE.FILLED_1, name: 'Filled 1' },
  { id: BANNER_TAG_TYPE.URGENT_FILLED_1, name: 'Urgent Filled 1' },
];
// matches the tag type svc-customer-communication defaults to when none is sent
export const DEFAULT_BANNER_TAG_TYPE = BANNER_TAG_TYPE.OUTLINE;

// read-only page that checks the schedule every segment resolves to for a send date
export const HERO_PLANNER_DEBUG_PATH = '/customer-communication/hero-planner/debug';

export enum HERO_PLANNER_DEBUG_SEARCH_PARAMS {
  SEND_DATE = 'send-date',
  OFFER_ID = 'offer-id',
  SHOW = 'show',
  COUNTRY_GROUP = 'country-group',
  SHOW_UNSENT = 'show-unsent',
}
